<template>
    <div>
        <div class="py-5">
            <h2>Warranty Management</h2>
        </div>

        <form class="needs-validation" novalidate v-on:submit.prevent="load()">
            <div class="container-fluid">
                <div class="form-group row p-2" v-bind:class="{'bg-danger': !source.valid.mac_addr, 'text-light': !source.valid.mac_addr}">
                    <div class="col-sm-10">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Mac address for claiming device</span>
                            </div>
                            <input type="text" class="form-control" placeholder="XX:XX:XX:XX:XX:XX" aria-label="XX:XX:XX:XX:XX:XX" v-model="source.data.mac_addr" v-bind:class="{'bg-danger': !source.valid.mac_addr}" pattern="^[a-fA-F0-9:]{17}|[a-fA-F0-9]{12}$">
                            <div class="input-group-append">
                                <button class="btn btn-primary" type="submit">Load Device ByMac Address</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <form class="needs-validation" novalidate v-on:submit.prevent v-if="source.response.id !== undefined && source.response.id !== null">
            <div class="container-fluid">
                <div class="form-group row p-2">
                    <div class="col-sm-10">
                        <h3>Warranty Claim Device [{{source.response.mac_addr}}] Details</h3>

                        <template v-if="source.transferFrom.length > 0">
                            <hr>
                            <div class="bg-secondary pr-2 pl-5">
                                <div class="bg-white" v-for="(device, index) in source.transferFrom">
                                    <h4 class="bg-secondary text-white mb-0 p-1">Device [{{source.transferFrom[index+1] === undefined ? source.response.mac_addr : source.transferFrom[index+1].mac_addr}}] Warranty Transfer from [{{device.mac_addr}}]</h4>
                                    <Device :source="device">
                                        <template slot="append">
                                            <tr v-if="device.warranty_claim_at !== undefined && device.warranty_claim_at !== null">
                                                <th>Warranty claimed already</th>
                                                <td>{{tools.formatDateTime(new Date(device.warranty_claim_at * 1000))}}</td>
                                            </tr>
                                        </template>
                                    </Device>
                                </div>
                            </div>
                            <hr>
                        </template>

                        <h4>Selected Device [{{source.response.mac_addr}}] Info</h4>
                        <div class="bg-primary pr-2 pl-5">
                            <Device class="bg-white" :source="source.response">
                                <template slot="append">
                                    <tr>
                                        <td colspan="2" v-if="source.response.building_id !== undefined && source.response.building_id !== null">
                                            <button class="btn btn-outline-secondary" type="button" disabled>Rest warranty</button>
                                        </td>
                                        <td colspan="2" v-else>
                                            <div class="input-group">
                                                <button class="btn btn-primary" type="button" v-on:click="resetWarrantyPopup(source.response)">Rest warranty</button>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </Device>
                        </div>

                        <template v-if="source.transferTo.length > 0">
                            <hr>
                            <div class="bg-secondary pr-2 pl-5">
                                <div class="bg-white" v-for="(device, index) in source.transferTo">
                                    <h4 class="bg-secondary text-white mb-0 p-1">Device [{{index === 0 ? source.response.mac_addr : source.transferTo[index-1].mac_addr}}] Warranty Transfer to [{{device.mac_addr}}]</h4>
                                    <Device :source="device">
                                        <template slot="append">
                                            <tr v-if="device.warranty_claim_at !== undefined && device.warranty_claim_at !== null">
                                                <th>Warranty claimed already</th>
                                                <td>{{tools.formatDateTime(new Date(device.warranty_claim_at * 1000))}}</td>
                                            </tr>
                                        </template>
                                    </Device>
                                </div>
                            </div>
                            <hr>
                        </template>

                    </div>
                </div>
            </div>
        </form>
        <div v-if="source.msg !== ''" class="container-fluid">
            <div class="form-group row p-2">
                <div class="col-sm-10">
                    <div class="alert alert-warning" role="alert">{{source.msg}}</div>
                </div>
            </div>
        </div>

        <div class="container-fluid">
            <div class="form-group row p-2">
                <div class="col-sm-10">
                    <template v-if="target.response_single.id !== undefined || target.response_single.id === null">
                        <h3>Load Device Details</h3>
                        <Device :source="target.response_single">
                            <template slot="append">
                                <tr v-if="source.response.warranty_claim_at === undefined || source.response.warranty_claim_at === null">
                                    <td colspan="2" v-if="target.response_single.warranty_claim_at === undefined || target.response_single.warranty_claim_at === null">
                                        <button class="btn btn-primary" type="button" v-on:click="transfer(source.response, target.response_single)">Transfer warranty from [{{source.response.mac_addr}}] to [{{target.response_single.mac_addr}}]</button>
                                    </td>
                                    <td colspan="2" v-else>
                                        <button class="btn btn-outline-secondary" type="button" disabled>Transfer warranty from [{{source.response.mac_addr}}] to [{{target.response_single.mac_addr}}]</button>
                                        <p v-if="target.response_single.warranty_transfer_from === source.response.id">
                                            Warranty successffully transfered between [{{source.response.mac_addr}}] and [{{target.response_single.mac_addr}}]
                                        </p>
                                        <p class="invalid-feedback d-block" v-else>Device warranty claimed</p>
                                    </td>
                                </tr>
                            </template>
                        </Device>
                    </template>
                    <div class="alert alert-warning" role="alert" v-if="target.response_single.msg !== ''">{{target.response_single.msg}}</div>
                    <template v-if="target.response.length > 0">
                        <h3>Found Replacing Device(s) Details</h3>
                        <template v-for="(device, index) in target.response">
                            <Device :source="device">
                                <template slot="append">
                                    <tr v-if="source.response.warranty_claim_at === undefined || source.response.warranty_claim_at === null">
                                        <td colspan="2">
                                            <button class="btn btn-primary" type="button" v-on:click="transfer(source.response, device)">Transfer warranty from [{{source.response.mac_addr}}] to [{{device.mac_addr}}]</button>
                                        </td>
                                    </tr>
                                </template>
                            </Device>
                            <div class="alert alert-warning" role="alert" v-if="device.msg !== ''">{{device.msg}}</div>
                        </template>
                    </template>
                    <div class="alert alert-warning" role="alert" v-if="target.msg !== ''">{{target.msg}}</div>
                </div>
            </div>
        </div>
        <ConfirmActionModalComponent v-if="dataToPassToModal.showModal"
                                     @close="dataToPassToModal.showModal = false"
                                     @execute="reset"
                                     :confirm="confirm"
                                     :dataToPassToModal="dataToPassToModal"
        ></ConfirmActionModalComponent>
    </div>
</template>

<script>
  import Vue from 'vue';
  import Tools from '@/app-model/tools';
  import Device from '@/components/warranty/Device';
  import DeviceModel from '@/app-model/deviceModel.js';
  import ConfirmActionModalComponent from '@/components/modal/ConfirmActionModalComponent.vue';

  export default {
    components:{
      Device,
      ConfirmActionModalComponent,
    },
    data () {
      return {
        deviceModels: {},
        dataToPassToModal: {
          showModal: false,
          submitDisabled: false,
          device: {}
        },
        confirm: {
          action: '',
          title: '',
          msg: {},
        },
        target: {
          msg: '',
          data: {
            mac_addr: '',
          },
          valid: {
            mac_addr: true,
          },
          response_single: {
            msg: '',
          },
          response: [],
        },
        source: {
          msg: '',
          data: {
            mac_addr: '',
          },
          valid: {
            mac_addr: true,
          },
          transferFrom: [],
          transferTo: [],
          response: {
            id: undefined,
            gateway_id: undefined,
            device_model_id: undefined,
            fitting_type_id: undefined,
            firmware_no: undefined,
            type: undefined,
            ip_addr: undefined,
            mac_addr: undefined,
            ble_version: undefined,
            python_ver: undefined,
            device_type: undefined,
            building_id: undefined,
            last_building_id: undefined,
            level: undefined,
            location: undefined,
            fitting_number: undefined,
            description: undefined,
            last_comm: undefined,
            device_model: {
              id: undefined,
              name: undefined,
              description: undefined,
            },
            files: [],
            fitting_type: {
              id: undefined,
              name: undefined,
              description: undefined,
            },
            status: undefined,
            manufacture_date: undefined,
            installation_date: undefined,
            activation_date: undefined,
            warranty: undefined,
            warranty_transfer_from: undefined,
            warranty_claim_at: undefined,
          }
        }
      }
    },
    computed: {
      tools: function () {
        return new Tools;
      },
      deviceModelTools: function () {
        return new DeviceModel;
      },
      sourceWarranty() {
        let warrantyExpiry = new Date(this.source.response.activation_date * 1000);
        warrantyExpiry.setDate(warrantyExpiry.getDate() + this.source.response.warranty)
        return warrantyExpiry;
      }
    },
    async mounted () {
      await this.getDeviceModel();
    },
    methods: {
      macUrlPath(str) {
        return str.replace(/\//g);
      },
      getDeviceModel () {
        this.deviceModelTools.all({store: this.$store}).then(({response, result}) => {
          let {device_models} = result;
          for (let i = 0; i < device_models.length; i++) {
            Vue.set(this.deviceModels, device_models[i]['id'], Object.assign({}, device_models[i]));
          }
          return {response, result};
        })
      },
      load() {
        this.source.transferFrom = [];
        this.source.transferTo = [];

        this.source.response = {};
        this.source.msg = '';
        this.target.response = [];
        this.target.msg = '';
        this.target.response_single = {};
        this.target.response_single.msg = '';

        let mac_addr = this.macUrlPath(this.source.data.mac_addr);
        if (mac_addr === "" || mac_addr.length < 15) {
          this.source.valid.mac_addr = true;
          return;
        }

        this.loadDeviceByMac(mac_addr)
          .then(response => {
            if (response.status === 200) {
              this.source.response = response.data.data;
              if (this.source.response.device_model_id) {
                this.source.response.device_model = this.deviceModels[this.source.response.device_model_id];
              }
              this.loadTransferFrom(this.source.response);
              this.loadTransferTo(this.source.response);
            }
            else {
              this.source.msg = response.data.message;
            }
            return response;
          });
      },
      loadTransferFrom(device){
        if(device.warranty_transfer_from > 0) {
          this.loadDeviceById(device.warranty_transfer_from).then(response => {
            if (response.status === 200) {
              let fromDevice = response.data.data;
              fromDevice.device_model = fromDevice.device_model_id ? this.deviceModels[fromDevice.device_model_id] : {};
              this.source.transferFrom.unshift(fromDevice);
              this.loadTransferFrom(fromDevice);
            }
          });
        }
      },
      loadTransferTo(device){
        this
          .$store
          .dispatch(
            'apiResult',
            {
              method: 'GET',
              path: `api/devices?warranty_transfer_from=${device.id}`,
              path_template: '/api/devices/{id}',
            }
          )
          .then(response => {
            if (response.status === 200 && response.data.data.length > 0) {
              let toDevice = response.data.data[0];
              toDevice.device_model = toDevice.device_model_id ? this.deviceModels[toDevice.device_model_id] : {};
              this.source.transferTo.push(toDevice);
              this.loadTransferTo(toDevice);
            }
          });
      },
      loadDeviceById(id){
        return this
          .$store
          .dispatch(
            'apiResult',
            {
              method: 'GET',
              path: `api/devices/${id}`,
              path_template: '/api/devices/{id}',
            }
          );
      },
      loadDeviceByMac(macAddr) {
        return this
          .$store
          .dispatch(
            'apiResult',
            {
              method: 'GET',
              path: `api/warranty/${this.macUrlPath(macAddr)}`,
              path_template: '/api/warranty/{replaced_mac_addr}',
            }
          );
      },
      transfer(sourceObj, targetObj) {
        targetObj.msg = '';
        let payload = {
          method: 'POST',
          path: `api/warranty/${this.macUrlPath(sourceObj.mac_addr)}/replacing_devices/${this.macUrlPath(targetObj.mac_addr)}`,
          path_template: '/api/warranty/{replaced_mac_addr}/replacing_devices/{replacing_mac_addr}',
        };
        this.$store.dispatch('apiResult', payload).then(response => {
            if (response.status === 200) {
              this.load();
            }
            else {
              Object.assign(targetObj, {
                msg: response.data.message
              });
            }
          }
        )
      },
      resetWarrantyPopup: function(device) {
        this.dataToPassToModal.device = {};
        Object.assign(this.dataToPassToModal.device, device);
        this.dataToPassToModal.showModal = true;

        this.confirm.action = `Reset Warranty`;
        this.confirm.title = `Reset Warranty for [${device.mac_addr}]`;
        this.confirm.msg = {'data': [`Reset Warranty will reset warranty expiration day, remove warranty transfer history, warranty claim records, also device network join date, as well commit date!`]};
      },
      reset: function (device) {
        return this.$store.dispatch('apiResult', {
          method: 'DELETE',
          path: `api/warranty/${device.mac_addr}`,
          path_template: '/api/warranty/{replaced_mac_addr}',
          building_id: this.id
        }).then(response => {
          switch (response.status) {
            case 200 :
              this.confirm.msg = {'data': ['Warranty reset done']};
              this.dataToPassToModal.showModal = false;
              this.load();
              break
            case 401 :
              this.confirm.msg = response.data;
              break
          }
          return response;
        });
      },
    }
  }
</script>